import { Box, Typography } from '@mui/material';
import React from 'react';

import { EnvironmentName, useGetEnv } from '@/api/util/useGetEnv.util.ts';
import { EnvironmentBannerStyles } from '@/layouts/private/topBar/styles/TopBar.styles.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type VisibleEnvironmentName = Exclude<EnvironmentName, 'prod'>;

const isVisibleEnvironment = (
  environmentName: EnvironmentName | undefined,
): environmentName is VisibleEnvironmentName => {
  return environmentName === 'dev' || environmentName === 'preview';
};

export const EnvironmentBanner: React.FC = () => {
  const { env } = useGetEnv();
  const { t } = useTranslationWithPrefix('layouts');
  const environmentName = env?.env;

  if (!isVisibleEnvironment(environmentName)) {
    return null;
  }

  return (
    <Box sx={EnvironmentBannerStyles(environmentName)}>
      <Typography component="strong" variant="f12Medium">
        {t(`environmentBanner.${environmentName}.title`)}
      </Typography>
      <Typography variant="f12Regular">
        {t(`environmentBanner.${environmentName}.description`)}
      </Typography>
    </Box>
  );
};
